import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';

const useProjects = () => {
  const {
    allContentfulProject: { nodes: allProjects, totalCount },
    allContentfulProjectStats: { nodes: projectStats },
  } = useStaticQuery(graphql`
    query getProjects {
      allContentfulProjectStats {
        nodes {
          capex
          opex
          pipeline
          totalProjects
          ipp
        }
      }
      allContentfulProject(sort: { fields: serial, order: ASC }) {
        totalCount
        nodes {
          id
          slug
          serial
          shortDescription
          title
          category
          date
          capacity
          location
          type
          position {
            lat
            lon
          }
          imageOne {
            fluid {
              ...GatsbyContentfulFluid
            }
          }
          imageTwo {
            fluid {
              ...GatsbyContentfulFluid
            }
          }
          data {
            childMarkdownRemark {
              html
            }
          }
        }
      }
    }
  `);
  return { allProjects, totalCount, projectStats };
};

export default useProjects;
